var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'sitebuilder-element-panel'  + _vm.hideControl(),attrs:{"data-fixed":_vm.fixedBanner(),"data-fixed-mobile":_vm.fixedBannerMobile(),"data-tag":_vm.dataTag()}},[_c('div',{staticClass:"panel panel-primary draggable container-fluid ",style:({
      'border-radius': _vm.radius,
      backgroundColor: _vm.backgroundColor,
      backgroundImage: _vm.backgroundImage,
      backgroundSize: _vm.backgroundSize,
      backgroundPosition: _vm.backgroundPosition,
      backgroundOrigin: _vm.backgroundOrigin,
      backgroundRepeat: _vm.backgroundRepeat,
      height : _vm.height,
      minHeight : _vm.minHeight,
      border : _vm.border,
      'box-shadow': _vm.boxShadow,
    }),attrs:{"id":this.internal_config.id,"element":"PanelComponent","data-hide-desktop":!this.internal_config.showDesktop,"data-hide-mobile":!this.internal_config.showMobile}},[_c('div',{staticClass:"panel-body container"},_vm._l((_vm.elements),function(element,index){return _c(element.name,{key:index,tag:"component",attrs:{"config":element.config,"childs":element.childs,"id":element.id,"height_start":index,"preview":_vm.preview}})}),1)])])}
var staticRenderFns = []

export { render, staticRenderFns }